import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter  } from 'react-router-dom';
import Routing from './Routing';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>

    {/* Routing listing */}
    <BrowserRouter>
      <Routing />
    </BrowserRouter>

  </React.StrictMode>
);


